<template>
	<section class="wrapper">
		<div>
			<label>状态&emsp;</label>
			<el-select v-model="state.code_order_status" style="width: 200px" placeholder="请选择" clearable>
				<el-option label="全部已兑换" value="1" />
				<el-option label="部分已兑换" value="2" />
				<el-option label="未兑换" value="3" />
			</el-select>
		</div>
		<div style="margin: 20px 0;">
			<el-button type="danger" plain @click="delete_code_order()"
				:disabled="state.checked_code_list.length==0">删除</el-button>
			<el-button type="primary" plain @click="buycode_dialog_show">购买激活码</el-button>
		</div>
		<el-table :data="state.code_tableData" style="width: 100%" v-loading="state.table_loading"
			:header-cell-style="{ textAlign: 'center',backgroundColor: '#fafafa',color:'#333'}"
			:cell-style="{ textAlign: 'center'}" @selection-change="handleSelectionChange">
			<el-table-column type="selection" width="55" />
			<el-table-column type="index" label="序号" width="55" />
			<el-table-column prop="status" label="订单号" />
			<el-table-column prop="status" label="激活码" show-overflow-tooltip />
			<el-table-column prop="status" label="购买数量" />
			<el-table-column prop="status" label="状态">
				<template #default="scope">
					<el-tag v-if="scope.row.status==1" type="success">全部已兑换</el-tag>
					<el-tag v-else-if="scope.row.status==2" type="primary">部分已兑换</el-tag>
					<el-tag v-else type="danger">未兑换</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="status" label="购买时间" />
			<el-table-column fixed="right" label="操作" min-width="200">
				<template #default="scope">
					<el-button link type="primary" size="small" @click.stop="look_code_info(scope.row)">查看</el-button>
					<el-button link type="danger" size="small" @click.stop="delete_code(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="pagination_div">
			<el-pagination v-model:current-page="state.currentPage" v-model:page-size="state.pageSize"
				:page-sizes="state.pagesizes" :background="true" layout="total, sizes, prev, pager, next, jumper"
				:total="state.code_tableData.length" @size-change="handleSizeChange"
				@current-change="handleCurrentChange" />
		</div>
		<el-dialog v-model="state.buy_code_visible" width="600" title="购买激活码">
			<el-form :model="state.buy_code_from" label-width="auto" style="max-width: 600px">
				<el-form-item label="产品型号">
					<el-radio-group v-model="state.buy_code_from.productmode">
						<el-radio v-for="product in state.product_types" :key="product.id" border
							:label="product.name" :value="product.id" :disabled="product.instance_count === 0">
							{{ product.name }} - {{ product.description }}
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="云机时长">
					<el-radio-group class="has-gap" v-model="state.buy_code_from.phone_duration">
						<el-radio :value="30" size="large" border>
							<div style="display: flex;justify-content: left;align-items: center">
								<span>30天</span>
							</div>
						</el-radio>
						<el-radio :value="90" size="large" border>
							<div style="display: flex;justify-content: left;align-items: center">
								<span>90天</span>
							</div>
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="云机数量">
					<el-input-number v-model="state.buy_code_from.buy_phone_code_count" :min="1" :max="10"
						@change="handleChange" />
				</el-form-item>
				<el-form-item label="激活码数量">
					<el-radio-group class="has-gap" v-model="state.buy_code_from.buy_code_count">
						<el-radio value="single" size="large" border>
							<div style="display: flex;justify-content: left;align-items: center">
								<span>一个激活码</span>
							</div>
						</el-radio>
						<el-radio value="multiple" size="large" border>
							<div style="display: flex;justify-content: left;align-items: center">
								<span>多个激活码</span>
							</div>
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="金额">
					<p style="font-size: 24px;font-weight: 900;color: #f22525;">￥5.00</p>
				</el-form-item>
				<el-form-item label="支付方式">
					<el-radio-group style="gap:10px;" v-model="state.buy_code_from.paymentMethod">
						<el-radio value="balance" size="large" border>
							<div style="display: flex;justify-content: left;align-items: center">
								<span>余额支付</span>
								<span style="margin-left: 10px;color: #666;font-size: 12px">当前余额:
									￥{{ store.state.Userdata.balance }}</span>
							</div>
						</el-radio>
						<el-radio value="alipay" size="large" border>
							<div style="display: flex;justify-content: left;align-items: center">
								<img src="@/assets/alipay.png" alt=""
									style="width: 30px;height: 30px;line-height: 30px;">
								<span>支付宝</span>
							</div>
						</el-radio>
						<el-radio value="wechat" size="large" border>
							<div style="display: flex;justify-content: left;align-items: center">
								<img src="@/assets/weixin.png" style="width: 30px;height: 30px;" />
								<span>微信支付</span>
							</div>
						</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<template #footer>
				<div class="dialog-footer">
					<el-button @click="state.buy_code_visible = false">取消</el-button>
					<el-button type="primary" @click="state.buy_code_visible = false">购买</el-button>
				</div>
			</template>
		</el-dialog>
		<el-dialog v-model="state.look_code_visible" width="300" title="查看激活码">
			<p class="row-code-view">
				<!-- current_row -->
				<span>7162781</span>
				<el-tag type="success">有效</el-tag>
				<!-- <el-tag type="info">失效</el-tag> -->
			</p>
			<template #footer>
				<div class="dialog-footer">
					<el-button type="primary" @click="state.look_code_visible = false">复制有效激活码</el-button>
				</div>
			</template>
		</el-dialog>
	</section>
</template>

<script setup>
	import {
		ref,
		reactive,
		computed,
		onMounted,
		onUnmounted,
		nextTick,
		watch,
	} from 'vue';
	import request from '@/utils'
	import {
		ElMessage,
		ElMessageBox,
		ElLoading,
		ElIcon
	} from 'element-plus';
	import {
		useStore
	} from 'vuex';
	const store = useStore();
	const state = reactive({
		buy_code_from: {
			phone_duration:30,
			buy_phone_code_count: 1, //购买激活码输入的云机数量
			buy_code_count: 'single', //购买激活码时数量配置
			paymentMethod: 'balance' ,//支付方式
			productmode:0
		},
		product_types:[], //产品型号列表数据
		code_order_status: '', //订单状态
		code_tableData: [{
			id: 1,
			status: 1
		}], // 激活码列表数据
		checked_code_list: [], //选中的激活码列表数据
		pagesizes: [10, 20, 30, 50, 100, 200], //可供用户选择的分页器的每页数据量数组
		currentPage: 1, //分页器当前页
		pageSize: 10, //分页器每页数据量
		table_loading: false,
		buy_code_visible: false, //购买激活码弹窗
		look_code_visible: false, //查看激活码弹窗
		current_row: null //激活码当前行数据
	})
	//表格check选中返回数据
	function handleSelectionChange(val) {
		state.checked_code_list = val
	}
	//查看单行激活码数据
	function look_code_info(row) {
		state.current_row = row
		state.look_code_visible = true
	}
	//获取激活码列表数据
	function Get_code_list() {

	}
	//购买激活码弹框弹出
	function buycode_dialog_show() {
		//获取产品型号列表数据
		request.get(`/products/list?all_android_version=1`).then((res)=>{
			console.log(res);
			state.product_types = res.data.data.ProductsList
			state.buy_code_from.productmode = res.data.data.ProductsList[0].id
			state.buy_code_visible=true
		})
	}
	//删除激活码数据
	function delete_code_order(row) {

	}
	//分页器的每页数据数量
	const handleSizeChange = (val) => {
		state.pageSize = val
		Get_code_list()
	}
	//获取分页器当前页
	const handleCurrentChange = (val) => {
		state.currentPage = val
		Get_code_list()
	}
	onMounted(async () => {
		await Get_code_list();
	});
</script>

<style lang="less" scoped>
	.wrapper {
		background-color: #fff;
		border-radius: 10px;
		position: relative;
		padding: 20px;
		box-sizing: border-box;
		text-align: left;

		.pagination_div {
			position: absolute;
			bottom: 20px;
			right: 20px;
		}
	}

	.buy-code-dialog-box {
		margin: 20px 0px;

		>div {
			margin: 10px 0;
		}

		.label-text {
			display: inline-block;
			min-width: 90px;
			text-align: right;
			margin-right: 20px;
		}
	}

	.row-code-view {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 20px;
		border-bottom: 1px solid #eee;
	}

	:deep(.el-form-item__label) {
		color: #333;
		font-weight: 900;
	}

	:deep(.el-dialog__title) {
		font-weight: 900;
	}
</style>